<template>
  <router-view v-slot="{ Component }">
    <!-- <transition name="route" mode="out-in"> -->
    <component :is="Component"></component>
    <!-- </transition> -->
  </router-view>
</template>

<style>
.route-enter-from {
  opacity: 0;
  transform: translateY(-100px);
}

.route-enter-active {
  transition: all 0.4s ease-out;
}

.route-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
